import pick from 'lodash/fp/pick'
import sortBy from 'lodash/fp/sortBy'
import { v1ApiNewPrice } from 'modules/Cube/communication/external/billingSchedule.api.v1/ports/entitySaving/useSavePrices'
import { v1ApiPrice } from 'Cube/communication/external/common.api.v1/ports/entityLoaders/useLoadPrices'
import { objectsAreEqualIgnoreUndefined } from '@sequencehq/utils'

export type DedupedPrice = {
  price: v1ApiNewPrice
  matchingNewPrices: v1ApiNewPrice[]
}

const pickPriceTerms = (price: v1ApiPrice | v1ApiNewPrice) => ({
  ...pick(
    [
      'listPriceId',
      'structure',
      'currency',
      'productId',
      'name',
      'integrationIds',
      'billingFrequency',
      'billingType',
      'usageCalculationPeriod'
    ],
    price
  ),
  customMetricParameters: sortBy(
    ['parameterId', 'value'],
    price.customMetricParameters
  )
})

export const pricesHaveSameTerms = (
  price: v1ApiPrice | v1ApiNewPrice,
  otherPrice: v1ApiPrice | v1ApiNewPrice
) =>
  objectsAreEqualIgnoreUndefined(
    pickPriceTerms(price),
    pickPriceTerms(otherPrice)
  )

export const dedupeSchedulePrices = (
  newPrices: (v1ApiPrice | v1ApiNewPrice)[]
): DedupedPrice[] => {
  return newPrices.reduce((acc: DedupedPrice[], currentPrice) => {
    const match = acc.find(dedupedPrice =>
      pricesHaveSameTerms(dedupedPrice.price, currentPrice)
    )

    if (!match) {
      return [
        ...acc,
        {
          price: currentPrice,
          matchingNewPrices: [currentPrice]
        }
      ]
    }

    return acc.map(dedupedConfig => {
      if (dedupedConfig.price.id === match.price.id) {
        return {
          ...dedupedConfig,
          matchingNewPrices: [...dedupedConfig.matchingNewPrices, currentPrice]
        }
      }

      return dedupedConfig
    })
  }, [])
}
